export default __webpack_public_path__ + "static/danny-085f5019954637873db64102731d4677.png";